<template>
  <section class="terminal-panel mt-4 flex min-h-[400px] flex-1 flex-col">
    <div
      v-if="state === 'loading'"
      class="flex flex-1 items-center justify-center"
    >
      <div class="text-center">
        <span class="loading loading-spinner text-primary mb-4"></span>
        <div class="text-base-content/80 mb-2 text-lg font-medium">
          Terminal tương tác...
        </div>
        <div class="text-base-content/60 text-sm">
          Agent sẽ nhận yêu cầu và kết nối tự động
        </div>
      </div>
    </div>
    <div
      v-else-if="state === 'failed'"
      class="flex flex-1 items-center justify-center"
    >
      <div class="text-center">
        <i
          class="fa-solid fa-triangle-exclamation text-warning mb-4 text-3xl"
        ></i>
        <div class="text-base-content/80 mb-2 text-lg font-medium">
          Terminal bị vô hiệu hóa
        </div>
        <div class="text-base-content/60 mb-4 text-sm">
          Tính năng terminal tương tác chưa được bật cho agent này. Hãy bật ở
          phần Cài đặt rồi thử lại.
        </div>
        <button class="btn btn-primary" @click="emit('retry')">Thử lại</button>
      </div>
    </div>
    <div v-else class="min-h-0 flex-1">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{ state: "loading" | "failed" | "connected" }>();
const emit = defineEmits<{ retry: [] }>();
</script>
